import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/leagues/$id')({
  component: RouteComponent,
});

export function RouteComponent() {
  const navigate = useNavigate();

  // Redirect to leagues list - leagues are read-only
  React.useEffect(() => {
    navigate({ to: '/dashboard/leagues' });
  }, [navigate]);

  return null;
}
